import { useState } from "react";
import { ClipboardList } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useLoginUser } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { WantedOverviewDialog } from "./WantedOverviewDialog";

export function WantedOverviewEntry({
  year,
  month,
  groupId,
  nurseRoles,
}: {
  readonly year: number;
  readonly month: number;
  readonly groupId: string;
  readonly nurseRoles?: readonly {
    readonly nurse_id: string;
    readonly role: string;
  }[];
}) {
  const [open, setOpen] = useState(false);
  const user = useLoginUser();
  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="outline"
            size="icon"
            className="relative size-9 before:absolute before:-inset-1"
            aria-label="원티드 요청 현황"
            title="원티드 요청 현황"
            onClick={() => setOpen(true)}
            disabled={!groupId}
            data-testid="wanted-overview-open"
          >
            <ClipboardList aria-hidden="true" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>원티드 요청 현황</TooltipContent>
      </Tooltip>
      {open && user && (
        <WantedOverviewDialog
          key={`${user.account_id}-${user.office_id}-${year}-${month}-${groupId}`}
          year={year}
          month={month}
          initialGroupId={groupId}
          nurseRoles={nurseRoles}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
